import type { FaireProductEntity } from "../../entity_types/product";

export const p_ucj7uyut6z: FaireProductEntity = {
  token: "p_ucj7uyut6z",
  type: "product",
  name: "Wheelin' Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c3b9a810b864a881c3cf2dafd67953560d763913c8b99a139a1b26ec36b10503.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e85d53c7e312b533c6d99bd505375fd93caca5c790a62aef88ff2106e678b3f.webp",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:06.934Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
